angular
  .module 'memberPortal'
  .directive 'addToHomescreenMessage', ($stateParams) ->
    restrict: 'EA'
    template: require('templates/member_portal/add_to_homescreen_message.html.slim')
    controller: ($scope, CwStorage) ->
      $scope.isAndroid = ->
        window.navigator.userAgent.indexOf('Android') > -1

      $scope.isIphone = ->
        window.navigator.userAgent.indexOf('iPhone') > -1

      $scope.isIpad = ->
        window.navigator.userAgent.indexOf('iPad') > -1

      $scope.isIos = ->
        $scope.isIphone() || $scope.isIpad()

      $scope.isDisplaying =
        ($scope.isAndroid() || $scope.isIos()) && !CwStorage.getItem('hideAddToHomeScreenMessage')

      $scope.hide = ->
        $scope.isDisplaying = false
        CwStorage.setItem('hideAddToHomeScreenMessage', false)
